// store/modules/whatsApp.js
import apiClient from "../../plugins/axios";

export default {
  namespaced: true,

  state: {
    whatsAppConnections: [],
    whatsAppAutomations: [],
  },

  mutations: {
    setWhatsAppConnections(state, connections) {
      state.whatsAppConnections = connections;
    },
    setWhatsAppAutomations(state, automations) {
      state.whatsAppAutomations = automations;
    },
  },

  actions: {
    async fetchWhatsAppConnections({ commit }, agencyId) {
      try {
        const response = await apiClient.get("/whatsapp/connections", {
          params: { agencyId },
        });
        commit("setWhatsAppConnections", response.data);
      } catch (error) {
        console.error("Error fetching WhatsApp connections:", error);
        if (error.response && error.response.status === 404) {
          commit("setWhatsAppConnections", []);
        }
      }
    },

    async fetchWhatsAppAutomations({ commit }, agencyId) {
      try {
        const response = await apiClient.get("/whatsapp/automations", {
          params: { agencyId },
        });
        commit("setWhatsAppAutomations", response.data);
      } catch (error) {
        console.error("Error fetching WhatsApp automations:", error);
        if (error.response && error.response.status === 404) {
          commit("setWhatsAppAutomations", []);
        }
      }
    },
  },

  getters: {
    whatsAppConnections: (state) => state.whatsAppConnections,
    whatsAppAutomations: (state) => state.whatsAppAutomations,
  },
};
